import { ApiOrg } from 'api/org/types/ApiOrg';
import { SecondaryButtonRouterLink } from 'components/Button';
import { AnchorButton } from 'components/Button/AnchorButton';
import { Button } from 'components/Button/Button';
import { Hide } from 'components/Hide';
import { trackClicked } from 'utils/analytics/track/trackClicked';

type Props = {
  org: ApiOrg;
  isPublished?: boolean;
  editMode: boolean;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setEditMode: (...args: Array<any>) => any;
};

export function ActionButtons({
  org,
  isPublished,
  editMode,
  setEditMode,
}: Props) {
  const editUrl = `/admin/${org.id}/edit`;

  const toggleEditMode = () => {
    trackClicked(`Org Profile: Admin ${editMode ? 'Preview' : 'Edit'} Mode`);
    setEditMode(!editMode);
  };

  return (
    <>
      {org.isFrozen && (
        <AnchorButton
          href="https://www.idealist.org/en/about/contact"
          size="small"
          variant="secondary-white"
        >
          {getText('Contact')}
        </AnchorButton>
      )}
      <SecondaryButtonRouterLink
        to={editUrl}
        data-qa-id="edit-button"
        size="small"
        reverse
        onClick={() => {
          if (!org.isFrozen && !isPublished) {
            trackClicked('Org Preview - Edit Org Profile');
          }
        }}
      >
        {getText('Edit')}
      </SecondaryButtonRouterLink>
      <Button
        size="small"
        onClick={toggleEditMode}
        data-qa-id="preview-button"
        variant="secondary-white"
      >
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line no-nested-ternary */}
        {!editMode ? (
          getText('View Edit Mode')
        ) : isPublished ? (
          <>
            <Hide sm md lg xl>
              {getText('Preview')}
            </Hide>
            <Hide xs>{getText('View Public Profile')}</Hide>
          </>
        ) : (
          getText('Preview')
        )}
      </Button>
      {!org.isFrozen && (org.is501c3 || isPublished) && (
        <SecondaryButtonRouterLink
          size="small"
          reverse
          to={`/admin/${org.id}/jobs/create`}
          onClick={() => {
            if (isPublished) {
              trackClicked('Org Profile - Post a Job');
            } else {
              trackClicked('Org Preview - Post a Job');
            }
          }}
        >
          {getText('Post a Job')}
        </SecondaryButtonRouterLink>
      )}
    </>
  );
}
